import type { LucideIcon } from "lucide-react";
import { InfoHint } from "@/components/InfoHint";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

export function ToggleChip({
  id,
  icon: Icon,
  label,
  checked,
  onCheckedChange,
  hint,
  disabled = false,
}: {
  id: string;
  icon: LucideIcon;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  hint: string;
  disabled?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex h-9 items-center gap-2 rounded-md border px-3 transition-colors",
        checked ? "border-accent-blue/40 bg-accent-blue/5" : "bg-card/60",
      )}
    >
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
      <Label
        htmlFor={id}
        className={cn(
          "flex items-center gap-1.5 text-xs font-medium",
          disabled ? "cursor-not-allowed text-muted-foreground" : "cursor-pointer",
        )}
      >
        <Icon className="size-3.5 text-muted-foreground" />
        {label}
      </Label>
      <InfoHint label={label}>{hint}</InfoHint>
    </div>
  );
}
